const productJson = {
    infor: {
        "title": '产品',
    },
    list: [{
            "id": 1,
            "data": [
                {
                    "id": 1,
                    "type": 'image',
                    "src": './images/product/1_v2.png',
                    "mobSrc": './images/product/mob/1_v2.png'
                }, {
                    "id": 2,
                    "type": 'text',
                    "title": '赛事活动运营指挥中心',
                    "text": '在运营监控中心，个性化移动终端，企业展示中心等场景，灵活展示实时运营数据，为赛事活动方提供全方位智慧管理与运维调度服务。',
                    "btn": '联系我们了解更多',
                    "link": '/contact-us',
                }
            ]
        },
        {
            "id": 2,
            "data": [
                {
                    "id": 1,
                    "type": 'text',
                    "title": '证件管理平台',
                    "text": '从区域资源管理到证件申请及定制化审批流程，利用人脸识别技术和创新的移动验检终端和穿戴设备，打造新一代安全，准确，便捷，灵活的证件全流程管理平台。',
                    "btn": '联系我们了解更多',
                    "link": '/contact-us',
                }, {
                    "id": 2,
                    "type": 'image',
                    "src": './images/product/2.png',
                    "mobSrc": './images/product/mob/2.png'
                }
            ]
        },
        {
            "id": 3,
            "data": [{
                    "id": 1,
                    "type": 'image',
                    "src": './images/product/3_v2.png',
                    "mobSrc": './images/product/mob/3_v2.png'
                }, {
                    "id": 2,
                    "type": 'text',
                    "title": '会员及活动体系平台',
                    "text": '实现个性化的活动发布及页面设计，为活动报名、活动现场参与及后续服务，提供包含自有线上门户，社交平台和实体渠道的全渠道会员识别，会员签到、优惠奖励发放等服务。',
                    "btn": '联系我们了解更多',
                    "link": '/contact-us',
                }
                
            ]
        },
    ],
}

export default productJson
